import {Component, OnChanges, SimpleChanges, input, output} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {MultiSelectModule} from 'primeng/multiselect';
import {DirectusTranslationPipe, LanguageCode} from '@frontend/directus';
import {TranslocoPipe} from '@jsverse/transloco';

interface LanguageOption {
  value: string;
  label: string;
  original: LanguageCode;
}

@Component({
  selector: 'app-language-multiselect',
  imports: [FormsModule, MultiSelectModule, TranslocoPipe],
  templateUrl: './language-multiselect.component.html',
})
export class LanguageMultiselectComponent implements OnChanges {
  readonly languages = input<LanguageCode[]>([]);
  readonly preSelectedLanguages = input<LanguageCode[]>([]);
  readonly activeLanguage = input('en');

  readonly selectedLanguagesChange = output<LanguageCode[]>();

  languageOptions: LanguageOption[] = [];
  selectedOptions: LanguageOption[] = [];
  private readonly directusTranslationPipe = new DirectusTranslationPipe();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['languages'] || changes['activeLanguage']) {
      this.updateLanguageOptions();
    }

    if (changes['preSelectedLanguages']) {
      this.updateSelectedOptions();
    }
  }

  private updateLanguageOptions(): void {
    this.languageOptions = this.languages().map((lang) => ({
      value: lang.isoCode,
      label:
        this.directusTranslationPipe.transform(lang.translations, this.activeLanguage()) ||
        lang.isoCode,
      original: lang,
    }));

    this.languageOptions.sort((a, b) => a.label.localeCompare(b.label));

    this.updateSelectedOptions();
  }

  private updateSelectedOptions(): void {
    const selectedCodes = new Set(this.preSelectedLanguages().map((lang) => lang.isoCode));
    this.selectedOptions = this.languageOptions.filter((option) => selectedCodes.has(option.value));
  }

  onSelectionChange(): void {
    const selectedLanguages = this.selectedOptions.map((option) => option.original);
    this.selectedLanguagesChange.emit(selectedLanguages);
  }
}
